const style = {
  row: {
    border: `1px solid transparent`,
    borderBottom: `1px solid #666`
  },
  rowActive: {
    background: `#fbfbfb`
  },
  header: {
    borderBottom: `1px solid #666`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/Community/partials/UserEditor/style/ColorBlind/list.js